import { toast } from 'sonner'

import { ImageUpload } from '@/components/ImageUpload/ImageUpload'

export interface SignatureProps {
  signature: string | null
  onUploadSuccess: () => void
}

export const Signature = (props: SignatureProps) => {
  return (
    <ImageUpload
      endpoint={import.meta.env.VITE_BACKEND_URL + '/api/v2/settings/signature'}
      label="Vybrat obrázek"
      preview={
        <div className="flex min-h-40 flex-col rounded-lg border">
          <p className="border-b px-4 py-2 text-xs text-muted-foreground">
            Současné razítko
          </p>
          <div className="grid flex-1 place-items-center p-4">
            {props.signature ? (
              <img
                src={
                  import.meta.env.VITE_BACKEND_URL +
                  '/media/watermark/' +
                  props.signature
                }
                alt="Razítko nebo podpis"
                width={200}
                height={100}
                className="max-h-28 object-contain"
              />
            ) : (
              <p className="text-sm text-muted-foreground">Zatím nic nahráno</p>
            )}
          </div>
        </div>
      }
      onUploadSuccess={() => {
        toast.success('Razítko bylo nahráno.')
        props.onUploadSuccess()
      }}
      onUploadError={() => {
        toast.error('Obrázek se nepodařilo nahrát.')
      }}
    />
  )
}
